module.exports = __webpack_public_path__ + "img/error-plane.e3a26f52.svg";